export default __webpack_public_path__ + "70ff48c12b5f21da19590d0311103aed.png";